import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    cards: {
      marginTop: '20px',
      gap: '20px',
    },
  });
